'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import { adjustElementHeights } from '@/shared/lib/swiper-utils';
import type { SwiperRef } from 'swiper/react';
interface UseCardsNavigationSwiperProps {
  cardsCount: number;
}
export function useCardsNavigationSwiper(t0) {
  const $ = _c(25);
  const {
    cardsCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      to: "md"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      from: "md",
      to: "xl"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isTabletOrDesktop1024 = useMediaQuery(t2);
  const MAX_ITEMS = isMobile ? 2 : isTabletOrDesktop1024 ? 3 : 5;
  const showSwiper = cardsCount > MAX_ITEMS;
  const isDeepLevel = cardsCount > 6;
  const itemsCount = cardsCount;
  const [isSwiperReady, setIsSwiperReady] = useState(false);
  const swiperRef = useRef(null);
  let t3;
  if ($[2] !== showSwiper) {
    t3 = () => {
      if (showSwiper) {
        adjustElementHeights(".swiper-milestone-card");
      } else {
        adjustElementHeights(".navigation-card-height");
      }
    };
    $[2] = showSwiper;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const adjustCardHeights = t3;
  let t4;
  if ($[4] !== adjustCardHeights) {
    t4 = () => {
      adjustCardHeights();
      requestAnimationFrame(() => {
        setIsSwiperReady(true);
      });
    };
    $[4] = adjustCardHeights;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleAfterInit = t4;
  let t5;
  if ($[6] !== adjustCardHeights) {
    t5 = () => {
      requestAnimationFrame(() => {
        adjustCardHeights();
      });
    };
    $[6] = adjustCardHeights;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const debouncedAdjustHeights = useDebounceCallback(t5, 150);
  let t6;
  if ($[8] !== adjustCardHeights || $[9] !== debouncedAdjustHeights || $[10] !== isSwiperReady) {
    t6 = () => {
      const adjustHeights = () => {
        requestAnimationFrame(() => {
          adjustCardHeights();
        });
      };
      const timeoutId = setTimeout(adjustHeights, 100);
      const handleResize = () => {
        debouncedAdjustHeights();
      };
      window.addEventListener("resize", handleResize);
      if (isSwiperReady) {
        adjustHeights();
      }
      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener("resize", handleResize);
      };
    };
    $[8] = adjustCardHeights;
    $[9] = debouncedAdjustHeights;
    $[10] = isSwiperReady;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== adjustCardHeights || $[13] !== cardsCount || $[14] !== debouncedAdjustHeights || $[15] !== isSwiperReady || $[16] !== showSwiper) {
    t7 = [showSwiper, adjustCardHeights, cardsCount, isSwiperReady, debouncedAdjustHeights];
    $[12] = adjustCardHeights;
    $[13] = cardsCount;
    $[14] = debouncedAdjustHeights;
    $[15] = isSwiperReady;
    $[16] = showSwiper;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  if ($[18] !== adjustCardHeights || $[19] !== handleAfterInit || $[20] !== isDeepLevel || $[21] !== isSwiperReady || $[22] !== itemsCount || $[23] !== showSwiper) {
    t8 = {
      swiperRef,
      isSwiperReady,
      handleAfterInit,
      adjustCardHeights,
      showSwiper,
      isDeepLevel,
      itemsCount
    };
    $[18] = adjustCardHeights;
    $[19] = handleAfterInit;
    $[20] = isDeepLevel;
    $[21] = isSwiperReady;
    $[22] = itemsCount;
    $[23] = showSwiper;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}